import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import { Input, Label, Button, Card, CardBody, Col, Row, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import "../../assets/css/--component-agent.css"
import { createCampaignFiles, createNewCampaign, getAllAgents, getConfiguration } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import { useNavigate } from 'react-router-dom'
import moment from 'moment';
import * as XLSX from "xlsx";
import { formatBytes, normalizePhoneNumber } from '../../common';
import Image from '../../components/Image'
import campaignSuccess from "../../assets/images/campaign-success.png"

const CreateNewCampaign = () => {
    const history = useNavigate();
    const today = moment().format("YYYY-MM-DD");
    const [loading, setLoading] = useState(false);
    const [newCampaign, setNewCampaign] = useState({ title: "", description: "", startDate: "", endDate: "", startTime: "00:00", endTime: "00:00" });
    const [agents, setAgents] = useState([])
    const [selectedAgent, setSelectedAgent] = useState({});
    const [viewModal, setViewModal] = useState(false);
    const [errors, setErrors] = useState({ title: "", prompt: "", firstMessage: false, file: "" });

    const DEFAULT_FIELDS = ["Phone", "Name", "Email", "Company", "Website"];
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [fieldMap, setFieldMap] = useState({});
    const [systemFields, setSystemFields] = useState(DEFAULT_FIELDS);
    const [showTable, setShowTable] = useState(false);
    const [mappedJson, setMappedJson] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newCustomField, setNewCustomField] = useState("");
    const [tags] = useState("");
    const [mappingObject, setMappingObject] = useState();
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    // const GHL_MODE = Number(localStorage.getItem("GHL"))
    const [GHL_MODE, setGhlMode] = useState([]);

    const STEPS = [
        { step: 1, label: "Campaign Info" },
        { step: 2, label: "Schedule" },
        { step: 3, label: "Map Fields" },
    ];
    const [activeStep, setActiveStep] = useState(1);
    const [maxStepReached, setMaxStepReached] = useState(1);

    useEffect(() => {
        fetchAgents();
        // localStorage.setItem("GHL", "1")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        fetchConfiguration();
    }, [])

    const fetchConfiguration = () => {
        setLoading(true)
        getConfiguration().then((data) => {
            if (data.data.length) {
                if (data.data[0]?.integration === "isGhl" && data.data[0]?.isEnabled === true){
                    setGhlMode(1)
                }
                else{
                    setGhlMode(0)
                }
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    const fetchAgents = () => {
        setLoading(true)
        setAgents([])
        getAllAgents().then((data) => {
            if (data.data.length) {
                setAgents(data.data ? data.data : [])
                setSelectedAgent(data.data[0])
                // getPromptsHandler(data.data[0])
            }
            else {
                history("/create-new-agent")
                showToast("error", "Request Failed", "Please create an agent first.")
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    const handleAgentchange = (id) => {
        const selectedID = id;
        const selectedItem = agents.find((item) => item._id === selectedID);
        setSelectedAgent(selectedItem ? selectedItem : []);
        // const newSelectedPrompt = prompts.find((item) => item._id === selectedItem.promptId);
        // setSelectedPrompt(newSelectedPrompt)
    };

    const handleStartDateChange = (e) => {
        const selectedDate = e.target.value;
        if (moment(selectedDate).isBefore(moment(), 'day')) {
            setNewCampaign((prev) => ({ ...prev, startDate: '', endDate: '' }));
        } else {
            setNewCampaign((prev) => ({
                ...prev,
                startDate: selectedDate,
                endDate: '', // Reset end date on start change
            }));
        }
    };

    const handleEndDateChange = (e) => {
        const selectedEndDate = e.target.value;
        const startDate = newCampaign.startDate;

        if (startDate && moment(selectedEndDate).isSameOrBefore(moment(startDate), 'day')) {
            // Invalid end date: clear it or show error
            setNewCampaign((prev) => ({
                ...prev,
                endDate: '',
            }));
        } else {
            setNewCampaign((prev) => ({
                ...prev,
                endDate: selectedEndDate,
            }));
        }
    };

    const handleStartTimeChange = (selectedTime) => {
        setNewCampaign((prev) => ({
            ...prev,
            startTime: selectedTime,
            endTime: '',
        }));
    };

    const handleEndTimeChange = (selectedEndTime) => {
        setNewCampaign((prev) => ({
            ...prev,
            endTime: selectedEndTime,
        }));
    };

    const validateStep1 = () => {
        let flag = false;
        const error = { ...errors, title: "", description: "" };

        if (!newCampaign.title || newCampaign.title.replace(/\s/g, '').length < 1) {
            flag = true;
            error.title = "Please provide valid title";
        }
        if (!newCampaign.description || newCampaign.description.replace(/\s/g, '').length < 1) {
            flag = true;
            error.description = "Please provide campaign description";
        }
        setErrors(error);
        return !flag;
    };

    const validateStep2 = () => {
        let flag = false;
        const error = { ...errors, startDate: "", endDate: "", startTime: "", endTime: "" };

        if (!newCampaign.startDate || newCampaign.startDate.replace(/\s/g, '').length < 1) {
            flag = true;
            error.startDate = "Please provide campaign's start date";
        }
        if (!newCampaign.endDate || newCampaign.endDate.replace(/\s/g, '').length < 1) {
            flag = true;
            error.endDate = "Please provide campaign's end date";
        }
        if (!newCampaign.startTime || newCampaign.startTime.replace(/\s/g, '').length < 1) {
            flag = true;
            error.startTime = "Please provide preferred start time";
        }
        if (!newCampaign.endTime || newCampaign.endTime.replace(/\s/g, '').length < 1) {
            flag = true;
            error.endTime = "Please provide preferred end time";
        }
        if (newCampaign.startTime && newCampaign.endTime) {
            const start = moment(newCampaign.startTime, "HH:mm");
            const end = moment(newCampaign.endTime, "HH:mm");

            if (end.isSameOrBefore(start)) {
                flag = true;
                error.endTime = "End time should be greater than start time";
            }
        }
        setErrors(error);
        return !flag;
    };

    const handleNextFromStep1 = () => {
        if (validateStep1()) {
            setActiveStep(2);
            setMaxStepReached((prev) => Math.max(prev, 2));
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleNextFromStep2 = () => {
        if (validateStep2()) {
            setActiveStep(3);
            setMaxStepReached((prev) => Math.max(prev, 3));
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleBackStep = () => {
        setActiveStep((prev) => Math.max(1, prev - 1));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const goToStep = (step) => {
        if (step <= maxStepReached) {
            setActiveStep(step);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // File mapping started
    const handleFileUpload = (e) => {
        const error = { file: "" };
        const selectedFiles = Array.from(e.target.files);

        const isValid = selectedFiles.every(file => {
            const fileType = file.name.split(".").pop();
            return fileType && ["xlsx"].includes(fileType.toLowerCase());
        });

        if (!isValid) {
            console.log("invalid file")
            clearFiles();
            error.file = "Only .xlsx files are allowed";
            setErrors(error)
            return;
        }
        // setErrors({...errors, file:""})
        const validSizeFiles = selectedFiles.filter(file => {
            const fileType = file.name.split(".").pop();
            return fileType && ["xlsx"].includes(fileType.toLowerCase());
        });

        const formattedFiles = validSizeFiles.map(file =>
            Object.assign(file, { formattedSize: formatBytes(file.size) })
        );
        setFiles(prev => [...prev, ...formattedFiles]);

        validSizeFiles.forEach(file => {
            const reader = new FileReader();
            reader.onload = (evt) => {
                const bstr = evt.target?.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                const [headers, ...rows] = data;

                setCsvHeaders(prev => Array.from(new Set([...prev, ...headers])));
                setCsvData(prev => [
                    ...prev,
                    ...rows
                        .filter(row => row.some(cell => cell != null && String(cell).trim() !== ""))
                        .map(row =>
                            Object.fromEntries(headers.map((header, i) => [header, row[i] || ""]))
                        )
                ]);

                setShowTable(false);
                console.log("csvheader", headers)
            };
            reader.readAsBinaryString(file);
        });
    };

    const handleMappingChange = (sysField, csvField) => {
        setFieldMap((prev) => ({ ...prev, [sysField]: csvField }));
    };

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleAddCustomField = () => {
        setNewCustomField("");
        toggleModal();
    };

    const handleSaveCustomField = () => {
        if (newCustomField && !systemFields.includes(newCustomField)) {
            setSystemFields([...systemFields, newCustomField]);
        }
        toggleModal();
    };

    const handleDeleteCustomField = (field) => {
        const updatedFields = systemFields.filter(f => f !== field);
        const updatedMap = { ...fieldMap };
        delete updatedMap[field];
        setSystemFields(updatedFields);
        setFieldMap(updatedMap);

        if (showTable) {
            const updatedJson = mappedJson.map((row) => {
                const newRow = { ...row };
                delete newRow[field];
                return newRow;
            });
            setMappedJson(updatedJson);
        }
    };

    const handleProceed = () => {
        let flag = false;
        let error = { file: false, phone: false };
        let mapped = [];

        const phoneField = systemFields.find(field => field.toLowerCase().includes("phone"));
        if (!fieldMap[phoneField]) {
            flag = true;
            error.phone = "Please map the phone number field.";
        }

        if (!csvHeaders.length) {
            if (!files.length) {
                flag = true;
                error.file = "Please provide at least one csv file to map.";
            }
        }
        if (csvData.length) {
            mapped = csvData.map((row) => {
                const mappedRow = {};
                let isValidRow = true;

                for (const sysField of systemFields) {
                    let value = row[fieldMap[sysField] || ""] || "";

                    if (sysField === phoneField) {
                        value = normalizePhoneNumber(value);
                        if (!value) {
                            isValidRow = false;
                            break;
                        }
                    }

                    mappedRow[sysField] = value;
                }

                return isValidRow ? mappedRow : null;
            }).filter(Boolean);
        }

        if (!flag) {
            const mappingPairs = {};
            for (const sysField of systemFields) {
                if (fieldMap[sysField]) {
                    mappingPairs[sysField] = fieldMap[sysField];
                }
            }
            setMappedJson(mapped);
            setMappingObject(mappingPairs);
            setShowTable(true);
            console.log("Mapped JSON to send to backend:", mapped);
            console.log("Field mapping:", mappingPairs);
        }

        setErrors(error);
    };
    // File mapping end

    const toCamelCaseKey = (key) => {
        return key.charAt(0).toLowerCase() + key.slice(1);
    }

    const handleSubmit = () => {
        let flag = false;
        let error = { file: false, phone: false, title: false, description: false, startDate: false, endDate: false, prompt: false, firstMessage: false };
        const allowedFields = Object.keys(mappingObject).map(toCamelCaseKey);

        const matches = selectedAgent.prompt.match(/\{\{([a-zA-Z0-9_]+)\}\}/g); // match {{field}}
        const invalidFields = matches
            ? matches
                .map(m => m.replace(/\{\{|\}\}/g, '')) // remove {{ and }}
                .filter(field => !allowedFields.includes(field))
            : [];

        const matchFirstMessage = selectedAgent.firstMessage.match(/\{\{([a-zA-Z0-9_]+)\}\}/g); // match {{field}}
        const invalidFieldsFirstMessage = matchFirstMessage
            ? matchFirstMessage
                .map(m => m.replace(/\{\{|\}\}/g, '')) // remove {{ and }}
                .filter(field => !allowedFields.includes(field))
            : [];

        if (invalidFieldsFirstMessage.length > 0) {
            flag = true;
            error.firstMessage = `Invalid dynamic field(s): ${invalidFieldsFirstMessage.map(f => `{{${f}}}`).join(", ")}`;
        }
        if (invalidFields.length > 0) {
            flag = true;
            error.prompt = `Invalid dynamic field(s): ${invalidFields.map(f => `{{${f}}}`).join(", ")}`;
        }
        setErrors(error)
        if (!flag) {
            setLoading(true);
            const customValusObj = Object.fromEntries(
                Object.entries(mappingObject).map(([key, value]) => [toCamelCaseKey(key), value])
            );
            const leadsJSON = mappedJson.map(obj =>
                Object.fromEntries(
                    Object.entries(obj).map(([key, value]) => [toCamelCaseKey(key), value])
                )
            );
            const formData = {
                agentId: selectedAgent._id,
                name: newCampaign.title,
                description: newCampaign.description,
                startDate: newCampaign.startDate,
                endDate: newCampaign.endDate,
                preferredTime: {
                    from: newCampaign.startTime,
                    to: newCampaign.endTime
                },
                prompt: selectedAgent.prompt,
                firstMessage: selectedAgent.firstMessage,
                ...(files.length && { leads: leadsJSON }),
                customFields: customValusObj,
                ...(!files.length && tags && { tag: tags }),
            }

            // for (let file of files) {
            //     formData.append(`files`, file);
            // }
            // console.log("formData", formData)
            createNewCampaign(formData).then((data) => {
                if ((data.status === 201 || data.status === 200) && data.statusText === "Created") {
                    if (files.length) {
                        let newCampaignId = data.data.campaignObj._id;
                        let formDataFile = new FormData();
                        formDataFile.append('campaignId', newCampaignId);
                        for (let file of files) {
                            formDataFile.append(`files`, file);
                        }
                        createCampaignFiles(formDataFile).then((data) => {
                            showToast("success", "Campaign Created", "Your new campaign has been created successfully.")
                            setLoading(false);
                            setViewModal(true)
                        }).catch((e) => {
                            showToast("error", "Campaign Request Failed", "Your new campaign could not be created.")
                            setLoading(false);
                        })
                    }
                    else {
                        showToast("success", "Campaign Created", "Your new campaign has been created successfully.")
                        setLoading(false);
                        setViewModal(true)
                    }
                }
                else if(data.data.message === "Campaign already exist with this tag."){
                    showToast("error", "Campaign Request Failed", "Campaign already exist with this tag")
                    setLoading(false);
                }
                else{
                    showToast("error", "Campaign Request Failed", "Your new campaign could not be created.")
                    setLoading(false);
                }
            }).catch((e) => {
                showToast("error", "Campaign Request Failed", "Your new campaign could not be created.")
                setLoading(false);
            })
        }
    }

    const clearFiles = () => {
        setFiles([]);
        setCsvHeaders([]);
        setCsvData([]);
        setShowTable(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="container-fluid">
                    <div className="py-3 row">
                        <div className="col-12">
                            <Row className="my-2 align-items-center">
                                <Col md={8}>
                                    <h4>Create New Campaign</h4>
                                    <p className='text-muted fs-12'>Create a new campaign</p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row>
                        <Col md={12}>
                            <Card className='bg-white rounded-2'>
                                <CardBody>
                                    <div className="campaign-wizard-steps d-flex align-items-center justify-content-center mb-4">
                                        {STEPS.map((s, idx) => (
                                            <React.Fragment key={s.step}>
                                                <div
                                                    className={`wizard-step d-flex align-items-center ${s.step <= maxStepReached ? 'cursor-pointer' : ''}`}
                                                    onClick={() => goToStep(s.step)}
                                                >
                                                    <div className={`wizard-step-circle ${activeStep === s.step ? 'active' : ''} ${s.step < activeStep ? 'completed' : ''}`}>
                                                        {s.step < activeStep ? <i className="ri-check-line"></i> : s.step}
                                                    </div>
                                                    <span className={`ms-2 wizard-step-label ${activeStep === s.step ? 'active' : ''}`}>{s.label}</span>
                                                </div>
                                                {idx < STEPS.length - 1 && <div className="wizard-step-divider"></div>}
                                            </React.Fragment>
                                        ))}
                                    </div>

                                    {activeStep === 1 && (
                                        <Row>
                                            <Col md={12}><h4 className='mb-4'>Campaign Details</h4></Col>
                                            <Col md={12} className='mb-4'>
                                                <Label htmlFor="prompt" className="text-left text-black font-bold"> Campaign Name </Label>
                                                <input id="prompt" className='custom-input form-control rounded border-0 py-2' type="text" value={newCampaign.title} onChange={(e) => { setNewCampaign((prev) => { return { ...prev, title: e.target.value } }); }} />
                                                {errors.title && <p className="invalid-feedback">{errors.title}</p>}
                                            </Col>
                                            <Col md={12} className='mb-4'>
                                                <Label htmlFor="prompt" className="text-left text-black font-bold"> Campaign Description </Label>
                                                <textarea value={newCampaign.description} onChange={(e) => { setNewCampaign((prev) => { return { ...prev, description: e.target.value } }); }} style={{ width: "100%", minHeight: "100px", maxHeight: "150px" }} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                                                {errors.description && <p className="invalid-feedback">{errors.description}</p>}
                                            </Col>
                                            <Col md={12} className='text-right'>
                                                <Button className="text-decoration-none rounded linear-gradient-btn" onClick={handleNextFromStep1}>
                                                    Next
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}

                                    {activeStep === 2 && (
                                        <Row>
                                            <Col md={12}><h4 className='mb-4'>Schedule</h4></Col>
                                            <Col md={6} className="mb-4">
                                                <Label htmlFor="startDate" className="text-left text-black font-bold">Campaign Start Date </Label>
                                                <input type="date" id="startDate" className={`form-control custom-input`} min={today} value={newCampaign.startDate} onChange={handleStartDateChange} />
                                                {errors.startDate && <p className="invalid-feedback">{errors.startDate}</p>}
                                            </Col>
                                            <Col md={6} className="mb-4">
                                                <Label htmlFor="endDate" className="text-left text-black font-bold">Campaign End Date </Label>
                                                <input type="date" id="endDate" className={`form-control custom-input`} min={newCampaign.startDate ? moment(newCampaign.startDate).add(1, 'day').format('YYYY-MM-DD') : ''} value={newCampaign.endDate} onChange={handleEndDateChange} disabled={!newCampaign.startDate} />
                                                {errors.endDate && <p className="invalid-feedback">{errors.endDate}</p>}
                                            </Col>
                                            <Col md={6} className="mb-4">
                                                <Label htmlFor="startTime" className="text-left text-black font-bold">Preferred Start Time <small className='text-danger'>(Will be considered as UTC)</small></Label>
                                                <input
                                                    type="time"
                                                    id="startTime"
                                                    className="form-control custom-input"
                                                    value={newCampaign.startTime}
                                                    onChange={(e) => handleStartTimeChange(e.target.value)}
                                                    disabled={!newCampaign.startDate}
                                                />
                                                {errors.startTime && <p className="invalid-feedback">{errors.startTime}</p>}
                                            </Col>

                                            <Col md={6} className="mb-4">
                                                <Label htmlFor="endTime" className="text-left text-black font-bold">Preferred End Time <small className='text-danger'>(Will be considered as UTC)</small></Label>
                                                <input
                                                    type="time"
                                                    id="endTime"
                                                    className="form-control custom-input"
                                                    value={newCampaign.endTime}
                                                    onChange={(e) => handleEndTimeChange(e.target.value)}
                                                    disabled={!newCampaign.startTime}
                                                />
                                                {errors.endTime && <p className="invalid-feedback">{errors.endTime}</p>}
                                            </Col>
                                            <Col md={12} className='d-flex justify-content-between'>
                                                <Button className="text-decoration-none rounded linear-gradient-btn" onClick={handleBackStep}>
                                                    Back
                                                </Button>
                                                <Button className="text-decoration-none rounded linear-gradient-btn" onClick={handleNextFromStep2}>
                                                    Next
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}

                                    {activeStep === 3 && (
                                        <>
                                            <Row>
                                                <div className="p-4">
                                                    <Row className="align-items-center">
                                                        <Col md={12}><h4 className='mb-4'>Map Fields</h4></Col>

                                                        {
                                                            // GHL_MODE ?
                                                            //     <>
                                                            //         <Col md={6}>
                                                            //             <Row>
                                                            //                 <Col md={10}>
                                                            //                     <input id="tags" className='custom-input form-control rounded border-0 py-2' placeholder='Please provide tags' type="text" value={tags} onChange={(e) => { setTags(e.target.value); }} />
                                                            //                 </Col>
                                                            //                 <Col md={2}>
                                                            //                     <Button disabled={loading} className="text-decoration-none rounded linear-gradient-btn" onClick={handleFetchTags}>
                                                            //                         {loading ? "Please Wait" : "Fetch Fields"}
                                                            //                     </Button>
                                                            //                 </Col>
                                                            //             </Row>
                                                            //         </Col>
                                                            //         <Col md={1} className='text-center'>-- OR --</Col>
                                                            //     </> : null
                                                        }
                                                        <Col md={5} className="text-end">
                                                            <input type="file" accept=".xlsx" multiple onChange={handleFileUpload} ref={fileInputRef} className='form-control' />
                                                            {files.length ? <p onClick={clearFiles}><small className='text-danger cursor-pointer'>Clear File</small></p> : null}
                                                            {/* {errors.file && <p className="invalid-feedback text-left">{errors.file}</p>} */}
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-5 align-items-center">
                                                        {
                                                            // GHL_MODE ?
                                                            //     <>
                                                            //         <Col md={6}>
                                                            //             <Row>
                                                            //                 <Col md={10}>
                                                            //                     {errors.tags && <p className="invalid-feedback">{errors.tags}</p>}
                                                            //                 </Col>
                                                            //                 <Col md={2}>
                                                            //                 </Col>
                                                            //             </Row>
                                                            //         </Col>
                                                            //         <Col md={1} className='text-center'></Col>
                                                            //     </> : null
                                                        }
                                                        <Col md={GHL_MODE ? "5" : "12"}>
                                                            {errors.file && <p className="invalid-feedback text-left">{errors.file}</p>}
                                                        </Col>
                                                    </Row>

                                                    {/* {csvHeaders.length > 0 && (
                                                        <>

                                                        </>
                                                    )} */}
                                                    <Row className="fw-bold text-muted mb-4">
                                                        <Col md={4} className='d-none d-md-block'>WiseRep Fields</Col>
                                                        <Col md={1} className='d-none d-md-block'></Col>
                                                        <Col md={5} className='d-none d-md-block'>Fields to Map</Col>
                                                    </Row>

                                                    {systemFields.map((sysField, index) => (
                                                        <Row className="align-items-center mb-3" key={index}>
                                                            <Col md={4} className="d-flex align-items-center justify-content-between">
                                                                <Label className="fw-bold mb-0">{sysField} {sysField !== "Phone" ? "(Optional)" : ""} {sysField === "Phone" ? <span className="text-danger fw-400 fs-20">*</span> : ""}</Label>

                                                            </Col>
                                                            <Col md={1} className="text-center d-none d-md-block">→</Col>
                                                            <Col md={5}>
                                                                <Row>
                                                                    <Col md={10}>
                                                                        <Input
                                                                            type="select"
                                                                            value={fieldMap[sysField] || ""}
                                                                            onChange={(e) => handleMappingChange(sysField, e.target.value)}
                                                                        >
                                                                            <option value="">Select Field</option>
                                                                            {csvHeaders.map((header) => (
                                                                                <option key={header} value={header}>{header}</option>
                                                                            ))}

                                                                        </Input>
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        {!DEFAULT_FIELDS.includes(sysField) && (
                                                                            <Button color='danger' className='btn btn-sm rounded' onClick={() => handleDeleteCustomField(sysField)}>
                                                                                <i className='ri-delete-bin-6-line fs-18'></i>
                                                                            </Button>
                                                                        )}</Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                    {errors.phone && <p className="invalid-feedback">{errors.phone}</p>}
                                                    <Row className='mt-4'>
                                                        <Col md={4}>
                                                            <Button className="text-decoration-none rounded linear-gradient-btn" onClick={handleBackStep}>
                                                                Back
                                                            </Button>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Button className="text-decoration-none rounded linear-gradient-btn" onClick={handleAddCustomField}>
                                                                <i className="ri-add-fill" ></i> Add Custom Field
                                                            </Button>
                                                        </Col>
                                                        <Col md={4} className='text-right'>
                                                            <Button className="text-decoration-none rounded linear-gradient-btn" onClick={handleProceed}>
                                                                Proceed
                                                            </Button>
                                                        </Col>
                                                    </Row>

                                                    <Modal isOpen={isModalOpen} toggle={toggleModal}>
                                                        <ModalHeader toggle={toggleModal}>Add Custom Field</ModalHeader>
                                                        <ModalBody>
                                                            <Input
                                                                placeholder="Enter custom field name"
                                                                value={newCustomField}
                                                                onChange={(e) => setNewCustomField(e.target.value.replace(/\s/g, ""))}
                                                            />
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button color="primary" onClick={handleSaveCustomField}>Save</Button>{" "}
                                                            <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                                                        </ModalFooter>
                                                    </Modal>

                                                    {showTable && mappedJson.length > 0 && (
                                                        <div className="mt-4">
                                                            <h5>Calls List Preview</h5>
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered">
                                                                    <thead className="table-light">
                                                                        <tr>
                                                                            {systemFields.map((field, index) => (
                                                                                <th key={index}>{field}</th>
                                                                            ))}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {mappedJson.map((row, rowIndex) => (
                                                                            <tr key={rowIndex}>
                                                                                {systemFields.map((field, colIndex) => (
                                                                                    <td key={colIndex}>{row[field]}</td>
                                                                                ))}
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Row>
                                            {
                                                showTable ?
                                                    <Row>
                                                        <Col md={12}>
                                                            <h4 className='mb-4'>Select An Agent</h4>
                                                            <Row>
                                                                <Col md={12} className='mb-4'>
                                                                    <Label htmlFor="agent" className="text-left text-black font-bold"> Agent </Label>
                                                                    <Input id="agent" className='custom-select rounded border-0 py-2' type="select" value={selectedAgent ? selectedAgent._id : ""} onChange={(e) => { handleAgentchange(e.target.value) }} >
                                                                        {agents.map((item) => (
                                                                            <option key={item._id} value={item._id}>
                                                                                {item.name}
                                                                            </option>
                                                                        ))}
                                                                    </Input>
                                                                </Col>
                                                            </Row>
                                                            <h4 className='mb-4'>Agent Prompt & Goals</h4>
                                                            <Row>
                                                                {/* <Col md={12} className='mb-4'>
                                                                    <Label htmlFor="prompttitle" className="text-left text-black font-bold"> Choose Prompt Template </Label>
                                                                    <Input id="prompttitle" className='custom-select rounded border-0 py-2' type="select" value={selectedPrompt._id ? selectedPrompt._id : ""} onChange={(e) => { handlePromptchange(e.target.value) }} >
                                                                        {prompts.map((item) => (
                                                                            <option key={item._id} value={item._id}>
                                                                                {item.title}
                                                                            </option>
                                                                        ))}
                                                                    </Input>
                                                                </Col> */}
                                                                {/* <Col md={12} className='mb-4'>
                                                                    <Label htmlFor="prompt" className="text-left text-black font-bold"> Title </Label>
                                                                    <Input id="prompt" disabled={true} className='custom-select rounded border-0 py-2' type="text" value={(selectedPrompt && selectedPrompt.title) || ""} onChange={(e) => { handlePromptchange(e.target.value) }} />
                                                                </Col> */}
                                                                <Col md={12} className='mb-4'>
                                                                    <Label htmlFor="firstMessage" className="text-left text-black font-bold"> First Message </Label>
                                                                    <small className='d-block fs-14 mb-2 fw-bold'><i className="ri-information-line text-primary"></i> You can use dynamic fields in your first message and prompt for example {Object.keys(mappingObject).map(key => `{{${toCamelCaseKey(key)}}}`).join(", ")}</small>
                                                                    <Input id="firstMessage" className='custom-input rounded border-0 py-2' type="text" value={(selectedAgent && selectedAgent.firstMessage) || ""} onChange={(e) => { setSelectedAgent((prev) => { return { ...prev, firstMessage: e.target.value } }); }} />
                                                                    {errors.firstMessage && <p className="invalid-feedback text-left">{errors.firstMessage}</p>}
                                                                </Col>
                                                                <Col md={12} className='mb-4'>
                                                                    <Label className="text-left text-black font-bold"> Prompt </Label>
                                                                    <textarea disabled={false} value={selectedAgent ? selectedAgent.prompt : ""} onChange={(e) => { setSelectedAgent((prev) => { return { ...prev, prompt: e.target.value } }); }} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                                                                    {errors.prompt && <p className="invalid-feedback text-left">{errors.prompt}</p>}
                                                                </Col>
                                                                <Col md={12} className='mb-4'>
                                                                    <Label htmlFor='purpose' className="text-left text-black font-bold"> Purpose </Label>
                                                                    <input disabled={true} type="text" id="purpose" className={`form-control custom-input`} value={(selectedAgent && selectedAgent.purpose) || ""} onChange={(e) => { setSelectedAgent((prev) => { return { ...prev, purpose: e.target.value } }); }} />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col md={12} className='text-right'>
                                                            <Button disabled={loading} onClick={() => { handleSubmit() }} className="px-4 py-2 rounded linear-gradient-btn">{loading ? "Please Wait" : "Create Campaign"}</Button>
                                                        </Col>
                                                    </Row> : null
                                            }
                                        </>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='md'>
                        <ModalBody>
                            <Row>
                                <Col md={12} className='text-center'>
                                    <Image src={campaignSuccess} alt="Event" className='rounded-circle me-2' height='200px' width='200px' objectFit='cover' />
                                    <h4>Campaign Created Successfully</h4>
                                    <p>A new agent with the name "<span className='fw-bold'>{selectedAgent.name} - {newCampaign.title}</span>" has been created, You can edit the campaign's prompt from agent management</p>
                                </Col>
                            </Row>
                            <Row className="text-center mt-3">
                                <Col>
                                    <Link to={"/campaigns"} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn">Go to Campaigns</Link>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        </div>
    )
}

export default CreateNewCampaign
